import Consts from 'Framework/Consts';
import useAppDispatch from 'Shared/Store/dispatch/useAppDispatch';
import { useAppSelector } from 'Shared/Store/useAppSelector';
import { addMinutes } from 'Shared/Utils/Extensions/Date/DateExtensions';

import MenuCategories from '../utils/MenuCategories.Storage';

import { IMenuCategory } from '../models/IMenuCategory';
import MenuCategorySliceType from '../reducers/MenuCategorySliceType';
import { setMenuCategories } from '../reducers/menuCategorySlice';
import getActiveMenuCategories from '../thunks/getActiveMenuCategories';

const useMenuCategoryStorage = () => {
  const dispatch = useAppDispatch();
  const modulesStorage = MenuCategories.getInstance();

  const { data } = useAppSelector<MenuCategorySliceType>((rootState: any) => rootState.common.menuCategory);

  const fillMenuCategoriesState = () => {
    if (
      modulesStorage.modulesHasValue() &&
      !modulesStorage.modulesIsExpire() &&
      modulesStorage.getMenuCategoriesWithExpiry()?.length > 0
    ) {
      const modulesResult: IMenuCategory[] = modulesStorage.getMenuCategoriesWithExpiry();
      if ((data?.length ?? 0) <= 0) {
        dispatch(setMenuCategories(modulesResult));
      }
    } else {
      const token = localStorage.getItem('token');
      if (token) {
        dispatch(getActiveMenuCategories()).then((result: any) => {
          if (result.payload) {
            modulesStorage.setMenuCategoriesWithExpiry(
              result.payload,
              addMinutes(new Date(), Number(Consts.env.REACT_APP_LOCAL_STORAGE_INTERVAL ?? 60))
            );
          }
        });
      }
    }
  };

  return { fillMenuCategoriesState };
};

export default useMenuCategoryStorage;
